import { GetTimezoneOffset, MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class ExportService {
  DoExportTaxWhtCertificatePndReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      pndId: input.pndId,
      pndType: input.pndType,
      isListItem: input.isListItem,
      isShowRefDocument: input.isShowRefDocument,
      receiveEmailList: input.receiveEmailList,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
    };
    return service.peakExportAPI
      .post("/api/EmailReport/ExportTaxWhtCertificatePndReport", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoExportTaxTransactionPP30Report(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      pp30Id: input.pp30Id,
      language: i18n.locale,
      financeType: input.financeType,
      isShowRefDocument: input.isShowRefDocument,
      isShowVatType: input.isShowVatType,
      receiveEmailList: input.receiveEmailList,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
    };
    return service.peakExportAPI
      .post("/api/EmailReport/ExportTaxTransactionPP30Report", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoExportTaxWhtCertificateReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      pndType: input.pndType,
      isListItem: input.isListItem,
      isShowRefDocument: input.isShowRefDocument,
      isSendEmail: input.isSendEmail,
      receiveEmailList: input.receiveEmailList,
      fromEmail: input.fromEmail,
    };
    return service.peakExportAPI
      .post("/api/EmailReport/ExportTaxWhtCertificateReport", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoExportTaxTransactionReport(input: any) {
    const _input = {
      merchantId: MerchantId(),
      timezoneOffset: GetTimezoneOffset(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      financeType: input.financeType,
      isShowVatType: input.isShowVatType,
      isShowRefDocument: input.isShowRefDocument,
      isSendEmail: input.isSendEmail,
      fromEmail: input.fromEmail,
      receiveEmailList: input.receiveEmailList,
      tableSortType: input.tableSortType,
      transactionTableSortColumnType: input.transactionTableSortColumnType,
    };
    return service.peakExportAPI
      .post("/api/EmailReport/ExportTaxTransactionReport", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ExportService();
